// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"default-module--wrapper--2hofi","layout":"default-module--layout--3m2tL","main":"default-module--main--2wx-o"};